import { addGroup, linkGroups, unlinkGroups } from "@redux/index";
import { EMPTY_GUID } from "@utils/helpers";
import { useSelector } from "react-redux";
import EditModeSwitch from "shared/components/edit-mode-switch";
import GenericTypeahead from "shared/dropdowns/GenericTypeahead";
import CreateNewItem from "shared/dropdowns/cx-dropdown/components/create-new-item";
import { SwitchProvider } from "shared/dynamic-imports";
import GroupComponent from "shared/ui-basics/ui-components/group-component";

export default function GroupDropdown({ object, setObject, recordType, link, unlink, menuListHeight, isOpen = false, isSwitchDisabled = false }) {
	const allGroups = useSelector((state) => state.libraries.group) || [];
	const linkedGroups = allGroups?.filter((group) => object?.groups?.includes(group.id)) || [];

	const handleLink = (id) => {
		linkGroups({ groupIds: [id], recordIds: [object.id], recordType: recordType });
		if (setObject) setObject({ ...object, groups: [...(object?.groups || []), id] });
	};

	const handleUnlink = (id) => {
		unlinkGroups({ groupIds: [id], recordIds: [object.id], recordType: recordType });
		if (setObject) setObject({ ...object, groups: object.groups.filter((currId) => currId !== id) });
	};

	const handleCreate = ({ input, clearInput, close }) => {
		close();
		addGroup({
			newGroup: {
				id: EMPTY_GUID,
				name: input,
				colorCode: "#64748B",
			},
			onSuccess: (group) => {
				clearInput();
				if (link) link(group?.id);
				else handleLink(group?.id);
			},
		});
	};

	const renderReadOnlyItems = () => (
		<>
			{linkedGroups?.map((group) => (
				<div key={group?.id}>
					<GroupComponent group={group} />
				</div>
			))}
		</>
	);

	const params = {
		selected: linkedGroups,
		options: allGroups,
		placeholder: "SEARCH_OR_CREATE",
		menuLabel: "SELECT_OR_CREATE",
		renderSelectedItem: (group) => (
			<div className="me-2">
				<GroupComponent key={group?.id} group={group} mode="unlinkable" action={unlink ?? handleUnlink} />
			</div>
		),
		renderMenuItem: ({ item }) => <GroupComponent group={item} />,
		linkMenuItem: link ? ({ item }) => link(item.id) : ({ item }) => handleLink(item.id),
		filter: ({ query, option }) => {
			const group = allGroups.find((g) => g.id === option?.id);
			if (group && !linkedGroups.map((lg) => lg?.id)?.includes(option?.id)) return group?.name?.toLowerCase().includes(query?.toLowerCase());
		},
		renderCreateItem: ({ input, clearInput, close }) => (
			<CreateNewItem
				create={() => handleCreate({ input, clearInput, close })}
				renderItem={() => <GroupComponent group={{ id: EMPTY_GUID, name: input, colorCode: "#64748B" }} />}
				createLabel="JS_87"
			/>
		),
		menuListHeight,
		isStrictOpen: isOpen ? isOpen : null,
	};

	return (
		<SwitchProvider initialValue={isOpen} isDisabled={isSwitchDisabled}>
			<EditModeSwitch addLabel="ADD_GROUP" renderReadOnlyItems={renderReadOnlyItems} isEmpty={linkedGroups?.length === 0} isDisabled={isSwitchDisabled}>
				<GenericTypeahead {...params} />
			</EditModeSwitch>
		</SwitchProvider>
	);
}
